var map = {
	"./icon-BARGAIN.png": "f4fe",
	"./icon-CHANGE_ADDRESS.png": "fff9",
	"./icon-CHANGE_APPOINTMENT_TIME.png": "a00f",
	"./icon-CHANGE_PROJECT.png": "bfaf",
	"./icon-DISPATCH_REDIRECT.png": "78fa",
	"./icon-ORDER_REPORT.png": "17840",
	"./icon-OTHER_ISSUE.png": "2a4d",
	"./icon-uploader.png": "0587"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cbb5";